import { useState, useEffect } from 'react';
//import './PinPageStyle.css';

function TermsPage() {
  const [language, setLanguage] = useState('EN')

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('lang');
    if (!lang || (lang.toUpperCase() !== 'EN' && lang.toUpperCase() !== 'AR')) {
      return;
    }
    setLanguage(lang.toUpperCase());
    handleLanguage(lang.toUpperCase());
  }, []);

  const handleLanguage = (value) => {
    var options = document.getElementById('language');
    var spans = options.getElementsByTagName('span');
    if (value === 'EN') {
      spans[0].style.color = 'black';
      spans[1].style.color = 'white';
      options.style.background = 'linear-gradient(to right, #fff 50%, #000 50%)';
      setLanguage('EN');
      return;
    }
    spans[0].style.color = 'white';
    spans[1].style.color = 'black';
    options.style.background = 'linear-gradient(to right, #000 50%, #fff 50%)'
    setLanguage('AR');
  }

  return (
    <div className="Aa5">
      <div className='top-form-content'>
        <div className='top-form-content-up'>
          <div className='logo'>
            <img fetchpriority='high' alt='' src={language === 'EN' ? '/kid-en.avif' : '/kid-ar.avif'} />
          </div>
          <div id='language' className='language'>
            <span onClick={() => handleLanguage('EN')}>EN</span>
            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeWidth="2" d="M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M12,23 C15,23 16,18 16,12 C16,6 15,1 12,1 C9,1 8,6 8,12 C8,18 9,23 12,23 Z M2,16 L22,16 M2,8 L22,8"></path></svg>
            <span onClick={() => handleLanguage('AR')}>AR</span>
          </div>
        </div>
        <div className='top-form-content-down'>
          <h4>{language === 'EN' ? 'Enjoy streaming now' : 'استمتع بالبث الآن'}</h4>
        </div>
      </div>
      <hr />
      <div className='bottom-form-content'>
        <div className='banner'>
          <div className='frame'>
            <img fetchpriority='high' alt='' src='/frame.avif' />
          </div>
          <div className='play'>
            <img fetchpriority='high' alt='' src='/play.avif' />
          </div>
        </div>

        <div className='terms'>
          {language === 'EN' ? <ul className='en'>
            <li>Kid Security is a subscription service available for STC users that costs 1 Riyal renewed daily for prepaid subscribers and costs 34.5 Riyals renewed monthly for postpaid subscribers (VAT Included)</li>
            <li>To unsubscribe send U 1 to 802460, VAT Tax was already paid with a refill card for prepaid subscribers</li>
            <li>For Mobily Subscribers the service price is 1.15 Riyal daily with a 1-day free trial for the first subscription(VAT Included)</li>
            <li>VAT Tax was already paid with a refill card for prepaid subscribers</li>
            <li>and to unsubscribe send U 58 to 607110</li>
          </ul> : <ul className='ar'>
            <li>امان الأطفال هي خدمة اشتراك متوفرة لعملاء شركة الاتصالات السعودية مقابل ١ ريال لعملاء مسبق الدفع تتجدد يومي وبمقابل ٣٤.٥ ريال لعملاء المفوتر تتجدد شهري (شامل قيمة الضريبة المضافة)</li>
            <li>ولإلغاء الاشتراك الرجاء ارسال غ ١ الى 802460</li>
            <li>تم تحصيل مبلغ الضريبة المضافة لعملاء مسبق الدفع عند عملية شحن الرصيد</li>
            <li>لمشتركين موبايلي سعر الخدمة 1.51 ريال يوميا مع تجربة مجانية ليوم واحد عند اشتراكك اول مره (شامل قيمة الضريبة المضافة)</li>
            <li>تم تحصيل مبلغ الضريبة لعملاء مسبق الدفع عند عملية شحن الرصي</li>
            <li>ولإلغاء الاشتراك أرسل غ ٥٨ إلى 607110</li>
          </ul>}
        </div>
      </div>
    </div>
  );
}

export default TermsPage;
